import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import defaultPic from './default-pic.png'
import { Link } from 'react-router'
import Masonry from 'react-masonry-component'
import GalleryItem from 'components/GalleryItem'
import Lightbox from 'react-images'

class Gallery extends React.Component {
  
  static propTypes () {
    return {
      images: React.PropTypes.array
    }
  }

  constructor() {
    super();
    this.masonryOptions = {
      transitionDuration: 0,
      fitWidth: true,
      gutter: 5
    };

    this.state = {
      lightboxIsOpen: false,
      currentIndex: 0
    }
  }

  openLightBoxWithImage(data) {
     this.setState({currentIndex: data.index});
    this.setState({ lightboxIsOpen: true });
  }

  gotoPrevLightboxImage() {
    if(this.state.currentIndex - 1 > 0){
      this.setState({currentIndex: this.state.currentIndex - 1});
    }
  }

  gotoNextLightboxImage() {
    if(this.state.currentIndex + 1 < this.props.images.length){
      this.setState({currentIndex: this.state.currentIndex + 1});
    }
  }

  closeLightbox() {
    this.setState({ lightboxIsOpen: false });
  }

  render () {

    let images = this.props.images || [];
    images = images.map((v, i) => {
      v.index = i;
      return v;
    });

    return (
      <div >
        <Masonry
          className={'masonry-gallery'}
          elementType={'ul'}
          options={this.masonryOptions}
          disableImagesLoaded={false}
          updateOnEachImageLoad={false}
        >
          {images.map(i => (
            <GalleryItem 
              data={i}
              key={i.index}
              onClick={(d) => {this.openLightBoxWithImage(d)}} 
            />
          ))}
        </Masonry>

        <Lightbox
          images={images}
          isOpen={this.state.lightboxIsOpen}
          currentImage={this.state.currentIndex}
          onClickPrev={() => {this.gotoPrevLightboxImage()}}
          onClickNext={() => {this.gotoNextLightboxImage()}}
          onClose={() => {this.closeLightbox()}}
        />
      </div>
    )
  }
}

export default Gallery



/** WEBPACK FOOTER **
 ** ../components/Gallery.js
 **/